<template>
    <input
        ref="input"
        :value="value"
        :placeholder="format"
        class="block w-full px-3 py-2 text-black placeholder-gray-400 transition duration-100 ease-in-out bg-white border border-gray-300 rounded shadow-sm focus:ring-1 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed focus:ring-green-500 focus:border-green-500"
    />
</template>

<script>
    import Pikaday from 'pikaday';
    import 'pikaday/css/pikaday.css';

    export default {
        props: {
            // eslint-disable-next-line vue/require-prop-types
            value: { required: true },
            format: {
                type: String,
                default: 'YYYY-MM-DD',
            },
            options: {
                type: Object,
                default: () => {},
            },
            disableFuture: {
                type: Boolean,
                default: false,
            },
        },

        mounted() {
            const config = {
                field: this.$refs.input,
                format: this.format,
                onSelect: () => {
                    this.$emit('input', this.picker.toString());
                },
                ...this.options,
            };
            if (this.disableFuture) {
                config.maxDate = new Date(); // today
            }

            this.picker = new Pikaday(config);
        },

        beforeDestroy() {
            if (this.picker) {
                this.picker.destroy();
            }
        },
    };
</script>
